export default function LeadIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.60667 9.99987L12.7317 14.1249L11.5533 15.3032L6.25 9.99987L11.5533 4.69653L12.7317 5.87487L8.60667 9.99987Z"
        fill="#469D18"
      />
    </svg>
  );
}
